/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData, FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataFromJSONTyped, FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataToJSON, } from './FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData';
export function FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataFromJSON(json) {
    return FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData(json)) {
        return FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataToJSON(json) {
    return FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingData(value)) {
        return FxIdApplicationStoreInAppGooglePlayGooglePlayInAppBillingDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreInAppInAppValidationRequestGoogleInAppBillingData.js.map